import axios from 'axios';
import { getStoredUserEmail } from '@/auth/useAuth';

/**
 * Istanza axios condivisa per tutte le chiamate all'API del Home Configurator.
 * L'header `x-user-email` sostituisce temporaneamente l'autenticazione reale.
 * TODO(Auth0): sostituire l'header x-user-email con un Bearer token Auth0
 * ottenuto via getAccessTokenSilently() quando l'integrazione sarà pronta.
 */
export const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
});

api.interceptors.request.use((config) => {
  const email = getStoredUserEmail();
  if (email) {
    config.headers['x-user-email'] = email;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (axios.isAxiosError(error) && error.response?.status === 401) {
      // Nessuna sessione valida: rimanda al login.
      window.location.href = '/login';
    }
    return Promise.reject(error);
  },
);
